<app-header></app-header>
<div class="form-wrapper">
	<div class="container">
		<div class="logo-container pb-15">
			<div class="logo-wrapper">
				<img alt="tenderpilot-logo" src="../../../assets/logo/tp-logo-voll-quer.svg" width="390">
			</div>
		</div>
		<div class="form">
			<div class="account-activation-form">
				<form *ngIf="isCodeExpired" nz-form [formGroup]="accountActivationForm"
					(ngSubmit)="submitResendAccountActivationForm()">
					<nz-form-item class="input-field">
						<nz-form-control>
							<nz-input-group class="icons" nzPrefixIcon="user">
								<input type="email" nz-input formControlName="email" autocomplete="email"
									[placeholder]="'global.login.placeholder.enter_email' | translate" />
							</nz-input-group>
							<app-validation-errors
								*ngIf="accountActivationForm.controls['email'].touched || accountActivationForm.controls['email'].dirty"
								[errors]="accountActivationForm.get('email').errors" label="email">
							</app-validation-errors>
						</nz-form-control>
					</nz-form-item>
					<button nz-button class="login-form-button login-form-margin btn-color-default" [nzType]="'primary'"
						nzBlock>
						<div *ngIf="!isCodeExpired">{{"global.account_activation.label.activate_account" | translate}}
						</div>
						<div *ngIf="isCodeExpired">
							{{ "global.account_activation.label.resend_account_activation_link" | translate}}</div>
					</button>
				</form>
				<div *ngIf="!isCodeExpired" nz-form class="forgot-password-form">
					<button nz-button class="login-form-button login-form-margin btn-color-default"
						(click)="submitAccountActivation()" [nzType]="'primary'" nzBlock>
						{{ "global.account_activation.label.activate_account" | translate }}</button>
				</div>
			</div>
		</div>
	</div>
</div>
<app-footer></app-footer>
